<template>
  <div>
    <h1 style="margin-left: 90px;"> {{StockFullName}}</h1><br/>
     <span>{{EndDate}}</span> - <span>{{StartDate}}</span><br/>
    <!-- <br />
    <br /> -->
    <select class="stocks custom-select" v-model="selected">
      <option
        v-bind:key="stock.symbol"
        v-for="stock in stocks"
        v-bind:value="stock.symbol"
      >{{stock.symbol}}</option>
    </select>
    <br />
  </div>
</template>

<script>
import Stock from "../../Utils/Stock.js";
import downArrowSelect from "../../assets/downArrowSelect.jpg"
export default {
  props: ["emitter", "ikey", "getData", "putData","stocks"],
  data() {
    return {
      selected: "",
      StockFullName: "Market Data",
      StartDate:"StartDate",
      EndDate:"EndDate",
    };
  },
  methods: {
    update() {
      if (this.ikey) {
          this.putData(this.ikey,this.selected)
      }
      if (this.emitter !== undefined) this.emitter.trigger("process");
    }
  },
  watch: {
    selected: function(newSelected, oldSelected) {
      if (newSelected !== undefined) {
        var startDay= this.stocks[newSelected].getStartDate();
        var endDay= this.stocks[newSelected].getEndDate();

        this.StockFullName = this.stocks[newSelected].getFullName();
        this.StartDate = `${startDay.getMonth()}/${startDay.getDate()}/${startDay.getFullYear()}`;
        this.EndDate = `${endDay.getMonth()}/${endDay.getDate()}/${endDay.getFullYear()}`;
        this.update();
      } else {
        this.StockFullName = "Market Data";
      }
    }
  },
  mounted(){
          if (this.getData !== undefined) {
              this.selected = this.getData(this.ikey);
    }
  }
};
</script>

<style>
/* The container must be positioned relative: */
.custom-select select {
 background: transparent;
   width: 268px;
   padding: 5px;
   font-size: 16px;
   line-height: 1;
   border: 0;
   border-radius: 0;
   height: 34px;
   -webkit-appearance: none;
 
}

.custom-select {
   width: 150px;
   height: 34px;
   overflow: hidden;
   background: url(../../assets/downArrowSelect.jpg) no-repeat right ;
   border: 1px solid #ccc;
   }
</style>
